import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useState } from 'react'
import { faWifi, faEdit, faTimes, faChevronLeft, faChevronRight, faPlus, faTrash } from '@fortawesome/free-solid-svg-icons';
import CountryList from '../../../country.json'
import axios from 'axios';
import { SERVER_URL } from '../../../config';
import toast from 'react-hot-toast';
import { useNavigate } from "react-router-dom";
import { useEffect } from 'react';

export default function UserNFT({ playerData, getPlayerData }) {
    console.log(playerData);
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});
    const [initialFormData, setInitialFormData] = useState({});
    const [isSaved, setIsSaved] = useState(true);

    const footballPositions = [
        { value: "Goalkeeper", label: "Goalkeeper" },
        { value: "Defender", label: "Defender" },
        { value: "Midfielder", label: "Midfielder" },
        { value: "Forward", label: "Forward" },
    ];

    const players = [
        {
            thumbnail: "/assets/player/player1.svg",
        },
        {
            thumbnail: "/assets/player/player2.svg",
        },
        {
            thumbnail: "/assets/player/player3.svg",
        },
        {
            thumbnail: "/assets/player/player4.svg",
        }
    ];
    const randomPlayer = players[Math.floor(Math.random() * players.length)];

    const [formData, setFormData] = useState({});

    useEffect(() => {
        setFormData({
            full_name: playerData?.full_name || '',
            nationality: playerData?.nationality || '',
            preferred_position: playerData?.preferred_position || '',
            player_id: playerData?.player_id || '',
            nft_value: playerData?.nft_value || '',
            goals: playerData?.goals || 0,
            assists: playerData?.assists || 0,
            tackles: playerData?.tackles || 0,
            saves: playerData?.saves || 0,
            height: playerData?.height || '',
            weight: playerData?.weight || '',
            date_of_birth: playerData?.date_of_birth || '',
            email: playerData?.email || '',
            club: playerData?.club || '',
            matchPlayed: playerData?.matchPlayed || 0,
            thumbnail: playerData?.image || randomPlayer.thumbnail,
            attributes: (() => {
                try {
                    const raw = playerData?.attributes;
                    if (!raw) return [{ key: '', value: '' }];
                    return typeof raw === 'string' ? JSON.parse(raw) : raw;
                } catch (err) {
                    console.error('Failed to parse attributes:', err);
                    return [{ key: '', value: '' }];
                }
            })()

        })

        if (playerData) {
            setInitialFormData(playerData);
            setIsSaved(true);
        }
    }, [playerData])




    const handleClose = () => {
        const hasChanges = JSON.stringify(formData) !== JSON.stringify(initialFormData);
        if (hasChanges && !isSaved) {
            toast.error("You made changes but didn't click Save Changes button");
            return;
        }
        setIsPopupOpen(false);
    };

    const handleCancel = () => {
    setFormData({
        ...formData,
        thumbnail: playerData?.image || randomPlayer.thumbnail,
    });
    setIsPopupOpen(false);
};


    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [currentImageIndex, setCurrentImageIndex] = useState(players.findIndex(p => p.image === formData.thumbnail) || 0);



    const validateField = (name, value) => {
        switch (name) {
            case 'full_name':
                if (!value) return 'Player name is required';
                if (value.length < 2) return 'Name must be at least 2 characters';
                if (value.length > 50) return 'Name cannot exceed 50 characters';
                if (!/^[A-Za-z\s]+$/.test(value)) return 'Name can only contain letters and spaces';
                return '';
            case 'nationality':
                return value ? '' : 'Nationality is required';
            case 'preferred_position':
                return value ? '' : 'Position is required';
            case 'height':
                if (!value) return 'Height is required';
                if (!/^[0-9]*\.?[0-9]*$/.test(value)) return 'Height must be a valid number';
                if (Number(value) > 10 || Number(value) <= 0) return 'Height must be between 0 and 10 ft';
                if (value.length > 4) return 'Height cannot exceed 4 characters';
                return '';
            case 'weight':
                if (!value) return 'Weight is required';
                if (!/^[0-9]*\.?[0-9]*$/.test(value)) return 'Weight must be a valid number';
                if (Number(value) > 150 || Number(value) <= 0) return 'Weight must be between 0 and 150 kg';
                if (value.length > 5) return 'Weight cannot exceed 5 characters';
                return '';
            case 'nft_value':
                if (!value) return 'NFT value is required';
                if (!/^[0-9]*\.?[0-9]*$/.test(value)) return 'NFT value must be a valid number';
                if (Number(value) > 1_000_000_000_000) return 'NFT value cannot exceed 1 trillion';
                if (value.length > 12) return 'NFT value cannot exceed 12 digits';
                return '';
            case 'matchPlayed':
            case 'goals':
            case 'assists':
            case 'tackles':
            case 'saves':
                if (value === '') return `${name.charAt(0).toUpperCase() + name.slice(1)} is required`;
                if (!/^[0-9]+$/.test(value)) return `${name.charAt(0).toUpperCase() + name.slice(1)} must be a valid integer`;
                if (value.length > 4) return `${name.charAt(0).toUpperCase() + name.slice(1)} cannot exceed 4 digits`;
                return '';
            default:
                return '';
        }
    };

    const validateAttributes = (attributes) => {
        const attrErrors = attributes.map((attr) => {
            if (!attr.key && !attr.value) return null; // Skip empty key-value pairs
            if (attr.key && !attr.value) return 'Value is required for this key';
            if (attr.key.length > 50 || attr.value.length > 50) return 'Key and value cannot exceed 50 characters';
            if (!/^[A-Za-z0-9\s]+$/.test(attr.key) || !/^[A-Za-z0-9\s]+$/.test(attr.value)) {
                return 'Key and value can only contain letters, numbers, and spaces';
            }
            return '';
        });
        return attrErrors;
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        let sanitizedValue = value;

        if (name === 'full_name') {
            if (!/^[A-Za-z\s]*$/.test(value)) return;
            if (value.length > 50) return;
        } else if (['height', 'weight', 'nft_value'].includes(name)) {
            if (!/^[0-9]*\.?[0-9]*$/.test(value)) return;
            if (name === 'height' && value.length > 4) return;
            if (name === 'weight' && value.length > 5) return;
            if (name === 'nft_value' && value.length > 12) return;
        } else if (['matchPlayed', 'goals', 'assists', 'tackles', 'saves'].includes(name)) {
            if (value !== '' && !/^[0-9]+$/.test(value)) return;
            if (value.length > 4) return;
        }
        setIsSaved(false);
        setFormData({ ...formData, [name]: sanitizedValue });
        setErrors({ ...errors, [name]: validateField(name, sanitizedValue) });
    };
    const handleImageSelect = (thumbnail, index) => {
        setFormData({ ...formData, thumbnail });
        setCurrentImageIndex(index);
    };

    const handlePrevImage = () => {
        setCurrentImageIndex((prev) => (prev === 0 ? players.length - 1 : prev - 1));
        setFormData({ ...formData, thumbnail: players[(currentImageIndex - 1 + players.length) % players.length].thumbnail });
    };

    const handleNextImage = () => {
        setCurrentImageIndex((prev) => (prev === players.length - 1 ? 0 : prev + 1));
        setFormData({ ...formData, thumbnail: players[(currentImageIndex + 1) % players.length].thumbnail });
    };


    const handleAttributeChange = (index, field, value) => {
        if (value.length > 50 || !/^[A-Za-z0-9\s]*$/.test(value)) return;

        const updatedAttributes = [...formData.attributes];
        updatedAttributes[index][field] = value;
        setFormData({ ...formData, attributes: updatedAttributes });

        const attrErrors = validateAttributes(updatedAttributes);
        setErrors({ ...errors, attributes: attrErrors });
    };

    const addAttribute = () => {
        setFormData({ ...formData, attributes: [...formData.attributes, { key: '', value: '' }] });
    };


    const removeAttribute = (index) => {
        if (formData.attributes.length > 1) {
            const updatedAttributes = formData.attributes.filter((_, i) => i !== index);
            setFormData({ ...formData, attributes: updatedAttributes });
            setErrors({ ...errors, attributes: validateAttributes(updatedAttributes) });
        }
    };


    const token = sessionStorage.getItem('player_token');

    const handleSubmit = async () => {


        console.log('handleSubmit called with formData:', formData);

        const newErrors = {};
        Object.keys(formData).forEach((key) => {
            if (key !== 'attributes' && key !== 'thumbnail' && key !== 'player_id' && key !== 'date_of_birth' && key !== 'email' && key !== 'club') {
                newErrors[key] = validateField(key, formData[key]);
            }
        });

        const attrErrors = validateAttributes(formData.attributes);
        newErrors.attributes = attrErrors;

        setErrors(newErrors);
        console.log("newErrors", newErrors)

        const hasFieldErrors = Object.values(newErrors).filter(e => typeof e === 'string').some(Boolean);
        const hasAttrErrors = attrErrors.some(Boolean);
        const hasErrors = hasFieldErrors || hasAttrErrors;

        if (hasErrors) {
            console.log('Validation errors:', newErrors);
            Object.values(newErrors).forEach(error => {
                if (error && typeof error === 'string') toast.error(error);
            });
            attrErrors.forEach((error, index) => {
                if (error) toast.error(`Attribute ${index + 1}: ${error}`);
            });
            return;
        }




        const filteredAttributes = formData.attributes.filter(attr => attr.key && attr.value);
        const payload = { ...formData, attributes: filteredAttributes };
        console.log('Submitting payload:', payload);
        try {
            const response = await axios.post(`${SERVER_URL}/api/v2/update-player-profile`,
                payload,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                }
            );
            console.log('API response:', response);


            if (response.status === 200) {
                toast.success('Profile updated successfully!');
                setIsSaved(true);
                getPlayerData()
                setIsPopupOpen(false);
            } else {
                toast.error('Unexpected response from server.');
            }
        } catch (error) {
            console.error('Error updating profile:', error);
            if (error.response?.status === 403) {
                toast.error(`${error?.response?.data?.error?.msg}`);
                setTimeout(() => {
                    toast.dismiss()
                    navigate('/player/Login');
                }, 1500);
            }
            const message =
                error.response?.data?.error || 'Failed to update profile. Please try again.';
            toast.error(message);
        }
    };

    const formatToUnit = (num) => {
        if (typeof num !== 'number') num = Number(num);

        if (isNaN(num)) return 'Invalid number';

        if (num >= 1_000_000_000_000) {
            return (num / 1_000_000_000_000).toFixed(2).replace(/\.00$/, '') + ' Trillion';
        } else if (num >= 1_000_000_000) {
            return (num / 1_000_000_000).toFixed(2).replace(/\.00$/, '') + ' Billion';
        } else if (num >= 1_000_000) {
            return (num / 1_000_000).toFixed(2).replace(/\.00$/, '') + ' Million';
        } else if (num >= 1_000) {
            return (num / 1_000).toFixed(2).replace(/\.00$/, '') + ' Thousand';
        } else {
            return num.toString();
        }
    };

    return (
        <div className='flex flex-col lg:flex-row gap-10 mt-14'>
            <div className='w-[100%] lg:w-[40%]'>
                {/* <div className='flex flex-col items-center'>
                    <FontAwesomeIcon icon={faWifi} className='text-2xl text-white' />
                    <p className='text-white font-semibold mt-2'>NFT</p>
                </div> */}
                <div className='mx-auto rounded-3xl w-[100%] lg:w-[75%]'>
                    <div className='rounded-3xl p-5 lg:p-8 bg-black shadow-lg'>
                        <div className='flex justify-center'>
                            <div className='h-[250px] w-[200px] overflow-hidden rounded-xl'>
                                <img src={formData?.thumbnail} className='h-full w-full object-cover' alt="Player" />
                            </div>
                        </div>
                        <div className='border border-gray-700 rounded-xl p-5 mt-8'>
                            <div className='flex justify-between items-center gap-5'>
                                <p className='font-medium text-lg text-white'>Player ID</p>
                                <p className='flex justify-end items-center gap-1 text-white'>
                                    #{playerData?.player_id}
                                </p>
                            </div>
                            <div className='flex justify-between items-center gap-5 mt-2'>
                                <p className='text-gray-400 font-medium text-lg'>NFT Value:</p>
                                {/* <p className='text-[#00FF00] font-semibold uppercase text-lg'> $ {formatToUnit(playerData.nft_value)}</p> */}
                                <p className='text-[#00FF00] font-semibold uppercase text-lg'> $ {playerData.nft_value}</p>
                            </div>
                        </div>
                        <button
                            onClick={() => setIsPopupOpen(true)}
                            className='mt-4 border border-white/15 bg-[#2B2B2B] group rounded-full py-2 px-3 relative overflow-hidden duration-500 hover:bg-[#5F33D6]/80 text-white font-bold flex items-center justify-center w-full transition-all'
                        >
                            <FontAwesomeIcon icon={faEdit} className='mr-2' />
                            Edit Profile
                        </button>
                    </div>
                </div>
            </div>
            <div className='w-[100%] lg:w-[60%]'>
                <div className='flex flex-col lg:flex-row gap-10 lg:gap-20 px-3 lg:px-0'>
                    <div className='w-[100%] lg:w-[50%] space-y-7'>
                        <p className='text-2xl max-w-full font-bold text-white'>
                            {playerData?.full_name}
                        </p>
                        <p className='flex justify-between gap-4 text-white'>Country <span className='font-medium'>
                            {CountryList.find((c) => c.label === playerData?.nationality) ? (
                                <>
                                    <span className="text-2xl">
                                        {CountryList.find((c) => c.label === playerData?.nationality)?.country_flag}
                                    </span>
                                    {CountryList.find((c) => c.label === playerData?.nationality)?.label}
                                </>
                            ) : (
                                playerData?.nationality
                            )}
                        </span></p>
                        <p className='flex justify-between gap-4 text-white'>Position <span className='font-medium'>{playerData?.preferred_position}</span></p>
                        <p className='flex justify-between gap-4 '>Club <span className='font-medium'>{playerData?.club || "Not Joined"}</span></p>
                        <p className='flex justify-between gap-4 text-white'>Matches <span className='font-medium'>{playerData?.matchPlayed || 0}</span></p>
                        <p className='flex justify-between gap-4 text-white'>Goals <span className='font-medium'>{playerData?.goals || 0}</span></p>
                        <p className='flex justify-between gap-4 text-white'>Assists <span className='font-medium'>{playerData?.assists || 0}</span></p>
                        <p className='flex justify-between gap-4 text-white'>Tackles <span className='font-medium'>{playerData?.tackles || 0}</span></p>
                        <p className='flex justify-between gap-4 text-white'>Saves <span className='font-medium'>{playerData?.saves || 0}</span></p>
                    </div>
                    <div className='w-[100%] lg:w-[50%]'>
                        <div className='border border-gray-700 rounded-2xl py-4 px-5'>
                            <p className='font-semibold flex justify-between text-lg text-white'> Height<span className='text-base text-[#00ff00]'>{playerData?.height} ft</span></p>
                            <p className='font-semibold flex justify-between text-lg text-white'> Weight<span className='text-base text-[#00ff00]'>{playerData?.weight} kg</span></p>
                            <p className='font-semibold flex justify-between text-lg text-white'> BMI<span className='text-base text-[#00ff00]'>{playerData?.bmi} </span></p>
                            <p className='mt-2 text-sm flex items-center justify-center text-white'>
                                <span>Attributes</span>
                            </p>
                            {(() => {
                                try {
                                    const attributes = typeof playerData?.attributes === 'string'
                                        ? JSON.parse(playerData.attributes)
                                        : playerData?.attributes || [];


                                    if (!Array.isArray(attributes) || attributes.length === 0) {
                                        return (
                                            <div className='flex justify-center items-center mt-4'>
                                                <p className='text-sm text-gray-400 italic text-center'>
                                                    No attributes available.
                                                </p>
                                            </div>
                                        );
                                    }
                                    return attributes.map((attr, index) => (
                                        <p key={index} className='mt-2 text-sm w-full    flex justify-between text-white'>
                                            <span className='font-semibold w-[40%] truncate'>{attr.key}</span>
                                            <span className='text-center w-[20%]'>{" -> "}</span>
                                            <span className='text-base text-right w-[40%] font-semibold text-[#00ff00]'>{attr.value}</span>
                                        </p>
                                    ));
                                } catch (error) {
                                    console.error('Error parsing player attributes:', error);
                                    return (
                                        <p className='mt-2 text-sm text-red-400'>
                                            Failed to load player attributes.
                                        </p>
                                    );
                                }
                            })()}

                        </div>
                        <div className='hidden lg:block'>
                            <div className='flex flex-col items-center'>
                                <div>
                                    <div className='w-1.5 h-1.5 bg-white rotate-45 mt-1'></div>
                                    <div className='w-1 border-l border-dashed h-5 ml-[3px]'></div>
                                </div>
                                <div className='p-5 bg-white/5 rounded-full'>
                                    <div className='p-5 bg-white/5 rounded-full'>
                                        <img src='/assets/others/Ball.svg' className='ball-spin' style={{ zIndex: 1 }} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {isPopupOpen && (
                <div className='fixed inset-0 bg-opacity-40 backdrop-blur-sm flex justify-center items-center z-50 transition-opacity duration-300'>
                    <div className='bg-black text-white p-8 rounded-2xl w-[90%] max-w-[1400px] max-h-[80vh] overflow-y-auto shadow-2xl duration-300 scale-95 border border-gray-700'>
                        <h2 className='text-2xl font-bold text-white mb-6'>Edit Player Profile</h2>
                        <div className='absolute top-3 right-3 bg-black z-10'>
                            <button
                                // onClick={() => setIsPopupOpen(false)}
                                onClick={handleClose}

                                className='text-gray-400 hover:text-white transition-colors duration-200'
                            >
                                <FontAwesomeIcon icon={faTimes} className='h-6 w-6' />
                            </button>
                        </div>
                        <div className='flex flex-col lg:flex-row gap-6'>
                            <div className='w-full lg:w-1/3 flex flex-col items-center'>
                                <div className='relative w-full h-[300px] overflow-hidden rounded-lg flex items-center justify-center'>
                                    <img
                                        src={players[currentImageIndex].thumbnail}
                                        className='w-full h-full object-contain'
                                        alt={players[currentImageIndex].name}
                                    />
                                    <button
                                        onClick={handlePrevImage}
                                        className='absolute left-2 top-1/2 -translate-y-1/2 bg-gray-800/70 p-2 rounded-full hover:bg-gray-800 transition-all z-10'
                                    >
                                        <FontAwesomeIcon icon={faChevronLeft} className='text-white' />
                                    </button>
                                    <button
                                        onClick={handleNextImage}
                                        className='absolute right-2 top-1/2 -translate-y-1/2 bg-gray-800/70 p-2 rounded-full hover:bg-gray-800 transition-all z-10'
                                    >
                                        <FontAwesomeIcon icon={faChevronRight} className='text-white' />
                                    </button>
                                </div>
                                <div className='flex gap-2 mt-4 overflow-x-auto'>
                                    {players.map((player, index) => (
                                        <img
                                            key={player.id}
                                            src={player.thumbnail}
                                            className={`w-16 h-16 object-cover rounded-lg cursor-pointer border-2 ${index === currentImageIndex ? 'border-[#5F33D6]' : 'border-gray-600'}`}
                                            alt={player.name}
                                            onClick={() => handleImageSelect(player.thumbnail, index)}
                                        />
                                    ))}
                                </div>

                                <div className='flex justify-end gap-4 mt-10'>
                                    <button
                                        type='button'
                                         onClick={handleCancel}
                                        className='bg-gray-600 hover:bg-gray-700 text-white font-semibold py-2 px-6 rounded-lg transition-all duration-200'
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type='submit'
                                        form='playerForm'
                                        onClick={handleSubmit}
                                        className='bg-gradient-to-r from-blue-500 to-indigo-600 hover:from-blue-600 hover:to-indigo-700 text-white font-semibold py-2 px-6 rounded-lg transition-all duration-200'
                                    >
                                        Save Changes
                                    </button>
                                </div>

                            </div>

                            <form onSubmit={handleSubmit} className='w-full lg:w-1/3 space-y-6'>
                                <div>
                                    <label className='block text-sm font-medium text-gray-300'>Player Name</label>
                                    <input
                                        type='text'
                                        name='full_name'
                                        value={formData.full_name}
                                        onChange={handleInputChange}
                                        className='mt-2 block w-full border border-gray-600 rounded-lg p-3 bg-black text-white focus:outline-none focus:ring-2 focus:ring-[#5F33D6]/80 transition-all duration-200'
                                        placeholder='Enter player name'
                                    />
                                    {errors.full_name && <p className='text-red-400 text-sm mt-1'>{errors.full_name}</p>}
                                </div>
                                <div>
                                    <label className='block text-sm font-medium text-gray-300'>Nationality</label>
                                    <select
                                        name='nationality'
                                        value={formData.nationality}
                                        onChange={handleInputChange}
                                        className='mt-2 block w-full border border-gray-600 rounded-lg px-3 h-[48px] bg-black text-white focus:outline-none focus:ring-2 focus:ring-[#5F33D6]/80 transition-all duration-200'
                                    >
                                        <option value='' className='bg-black'>Select a country</option>

                                        {CountryList.map((country, index) => (
                                            <option key={`${country.label}-${index}`} value={country.label} className='bg-black'>
                                                {country.label} {country.country_flag}
                                            </option>
                                        ))}

                                    </select>
                                    {errors.nationality && <p className='text-red-400 text-sm mt-1'>{errors.nationality}</p>}
                                </div>
                                <div>
                                    <label className='block text-sm font-medium text-gray-300'>Position</label>
                                    <select
                                        name='preferred_position'
                                        value={formData.preferred_position}
                                        onChange={handleInputChange}
                                        className='mt-2 block w-full border border-gray-600 rounded-lg px-3 h-[49px] bg-black text-white focus:outline-none focus:ring-2 focus:ring-[#5F33D6]/80 transition-all duration-200'
                                    >
                                        <option value='' className='bg-black'>Select a position</option>
                                        {footballPositions.map((position) => (
                                            <option key={position.value} value={position.value} className='bg-black'>
                                                {position.label}
                                            </option>
                                        ))}
                                    </select>
                                    {errors.preferred_position && <p className='text-red-400 text-sm mt-1'>{errors.preferred_position}</p>}
                                </div>
                                <div>
                                    <label className='block text-sm font-medium text-gray-300'>Matches Played</label>
                                    <input
                                        type='number'
                                        name='matchPlayed'
                                        value={formData.matchPlayed}
                                        onChange={handleInputChange}
                                        className='mt-2 block w-full border border-gray-600 rounded-lg p-3 bg-black text-white focus:outline-none focus:ring-2 focus:ring-[#5F33D6]/80 transition-all duration-200'
                                        placeholder='Enter matches played'
                                        onKeyDown={(e) => {
                                            const allowed = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'];
                                            if (!/^[0-9]$/.test(e.key) && !allowed.includes(e.key)) {
                                                e.preventDefault();
                                            }
                                        }}
                                    />
                                    {errors.matchPlayed && <p className='text-red-400 text-sm mt-1'>{errors.matchPlayed}</p>}
                                </div>
                                <div>
                                    <label className='block text-sm font-medium text-gray-300'>Height (ft)</label>
                                    <input
                                        type='text'
                                        name='height'
                                        value={formData.height}
                                        onChange={handleInputChange}
                                        className='mt-2 block w-full border border-gray-600 rounded-lg p-3 bg-black text-white focus:outline-none focus:ring-2 focus:ring-[#5F33D6]/80 transition-all duration-200'
                                        placeholder='Enter height'
                                    />
                                    {errors.height && <p className='text-red-400 text-sm mt-1'>{errors.height}</p>}
                                </div>
                                <div>
                                    <label className='block text-sm font-medium text-gray-300'>NFT value in dollars</label>
                                    <input
                                        type='text'
                                        name='nft_value'
                                        value={formData.nft_value}
                                        onChange={handleInputChange}
                                        className='mt-2 block w-full border border-gray-600 rounded-lg p-3 bg-black text-white focus:outline-none focus:ring-2 focus:ring-[#5F33D6]/80 transition-all duration-200'
                                        placeholder='NFT value in dollars'
                                    />
                                    {errors.nft_value && <p className='text-red-400 text-sm mt-1'>{errors.nft_value}</p>}
                                </div>
                            </form>

                            <div className='w-full lg:w-1/3 space-y-6'>
                                <div>
                                    <label className='block text-sm font-medium text-gray-300'>Goals</label>
                                    <input
                                        type='number'
                                        name='goals'
                                        value={formData.goals}
                                        onChange={handleInputChange}
                                        className='mt-2 block w-full border border-gray-600 rounded-lg p-3 bg-black text-white focus:outline-none focus:ring-2 focus:ring-[#5F33D6]/80 transition-all duration-200'
                                        placeholder='Enter goals'
                                        onKeyDown={(e) => {
                                            const allowed = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'];
                                            if (!/^[0-9]$/.test(e.key) && !allowed.includes(e.key)) {
                                                e.preventDefault();
                                            }
                                        }}
                                    />
                                    {errors.goals && <p className='text-red-400 text-sm mt-1'>{errors.goals}</p>}
                                </div>
                                <div>
                                    <label className='block text-sm font-medium text-gray-300'>Assists</label>
                                    <input
                                        type='number'
                                        name='assists'
                                        value={formData.assists}
                                        onChange={handleInputChange}
                                        className='mt-2 block w-full border border-gray-600 rounded-lg p-3 bg-black text-white focus:outline-none focus:ring-2 focus:ring-[#5F33D6]/80 transition-all duration-200'
                                        placeholder='Enter assists'
                                        onKeyDown={(e) => {
                                            const allowed = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'];
                                            if (!/^[0-9]$/.test(e.key) && !allowed.includes(e.key)) {
                                                e.preventDefault();
                                            }
                                        }}
                                    />
                                    {errors.assists && <p className='text-red-400 text-sm mt-1'>{errors.assists}</p>}
                                </div>
                                <div>
                                    <label className='block text-sm font-medium text-gray-300'>Tackles</label>
                                    <input
                                        type='number'
                                        name='tackles'
                                        value={formData.tackles}
                                        onChange={handleInputChange}
                                        className='mt-2 block w-full border border-gray-600 rounded-lg p-3 bg-black text-white focus:outline-none focus:ring-2 focus:ring-[#5F33D6]/80 transition-all duration-200'
                                        placeholder='Enter tackles'
                                        onKeyDown={(e) => {
                                            const allowed = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'];
                                            if (!/^[0-9]$/.test(e.key) && !allowed.includes(e.key)) {
                                                e.preventDefault();
                                            }
                                        }}
                                    />
                                    {errors.tackles && <p className='text-red-400 text-sm mt-1'>{errors.tackles}</p>}
                                </div>
                                <div>
                                    <label className='block text-sm font-medium text-gray-300'>Saves</label>
                                    <input
                                        type='number'
                                        name='saves'
                                        value={formData.saves}
                                        onChange={handleInputChange}
                                        className='mt-2 block w-full border border-gray-600 rounded-lg p-3 bg-black text-white focus:outline-none focus:ring-2 focus:ring-[#5F33D6]/80 transition-all duration-200'
                                        placeholder='Enter goal saves'
                                        onKeyDown={(e) => {
                                            const allowed = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'];
                                            if (!/^[0-9]$/.test(e.key) && !allowed.includes(e.key)) {
                                                e.preventDefault();
                                            }
                                        }}
                                    />
                                    {errors.saves && <p className='text-red-400 text-sm mt-1'>{errors.saves}</p>}
                                </div>
                                <div>
                                    <label className='block text-sm font-medium text-gray-300'>Weight (kg)</label>
                                    <input
                                        type='text'
                                        name='weight'
                                        value={formData.weight}
                                        onChange={handleInputChange}
                                        className='mt-2 block w-full border border-gray-600 rounded-lg p-3 bg-black text-white focus:outline-none focus:ring-2 focus:ring-[#5F33D6]/80 transition-all duration-200'
                                        placeholder='Enter weight'
                                    />
                                    {errors.weight && <p className='text-red-400 text-sm mt-1'>{errors.weight}</p>}
                                </div>
                                <div>
                                    <label className='block text-sm font-medium text-gray-300'>Attributes</label>
                                    {formData.attributes.map((attr, index) => (
                                        <>
                                            <div key={index} className='flex items-center gap-2 mt-2'>
                                                <input
                                                    type='text'
                                                    placeholder='Key'
                                                    value={attr.key}
                                                    onChange={(e) => handleAttributeChange(index, 'key', e.target.value)}
                                                    className='block w-1/2 border border-gray-600 rounded-lg p-3 bg-black text-white focus:outline-none focus:ring-2 focus:ring-[#5F33D6]/80 transition-all duration-200'
                                                />
                                                <input
                                                    type='text'
                                                    placeholder='Value'
                                                    value={attr.value}
                                                    onChange={(e) => handleAttributeChange(index, 'value', e.target.value)}
                                                    className='block w-1/2 border border-gray-600 rounded-lg p-3 bg-black text-white focus:outline-none focus:ring-2 focus:ring-[#5F33D6]/80 transition-all duration-200'
                                                />
                                                {formData.attributes.length > 1 && (
                                                    <button
                                                        type='button'
                                                        onClick={() => removeAttribute(index)}
                                                        className='text-gray-400 hover:text-white'
                                                    >
                                                        <FontAwesomeIcon icon={faTrash} />
                                                    </button>
                                                )}
                                            </div>
                                            {errors.attributes?.[index] && <p className='text-red-400 text-sm mt-1'>{errors.attributes[index]}</p>}
                                        </>
                                    ))}
                                    <button
                                        type='button'
                                        onClick={addAttribute}
                                        className='mt-2 bg-gray-600 hover:bg-gray-700 text-white font-semibold py-2 px-4 rounded-lg flex items-center'
                                    >
                                        <FontAwesomeIcon icon={faPlus} className='mr-2' />
                                        Add Attribute
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}